import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import DateHelper from 'src/app/helpers/date-helper';
import { Tour } from 'src/app/model/tour/tour';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _post } from '../../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class TourToggleControllerRequestService {
  private readonly post: <T>(
    path: string,
    body: null,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res: Tour): Tour => {
    if (res != null) {
      res.date = res.date == null ? null : DateHelper.parseDate(res.date);
    }
    return res;
  };
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post('/tours', requestServices);
  }

  public toggleAbsence(placerId: number, dateString: string): Promise<Tour> {
    return this.post(
      `/toggleAbsence/${placerId}/${dateString}`,
      null,
      this.deserialize
    ).toPromise();
  }

  public toggleChecked(placerId: number, dateString: string): Promise<Tour> {
    return this.post(
      `/toggleChecked/${placerId}/${dateString}`,
      null,
      this.deserialize
    ).toPromise();
  }
}
